import { FC, ReactNode } from "react";
import { Navigate } from "react-router";

import { DEFAULT_AUTHENTICATED_ROUTE } from "../../constants/routes";
import { useAppSelector } from "../../hooks";
import { selectAuthIsSuperuser } from "../../store/selectors/auth";



type SuperuserRouteGuardProps = {
  children: ReactNode;
};

const SuperuserRouteGuard: FC<SuperuserRouteGuardProps> = ({ children }) => {
  const isSuperuser = useAppSelector(selectAuthIsSuperuser);

  if (!isSuperuser) {
    return <Navigate to={DEFAULT_AUTHENTICATED_ROUTE} replace />;
  }

  return <>{children}</>;
};

export default SuperuserRouteGuard;
